import { Check, Copy } from 'lucide-react'
import { useState } from 'react'

const FEEDBACK_DURATION_MS = 2000

export function CopyButton({ value }: { value: string }): React.JSX.Element {
  const [copied, setCopied] = useState(false)

  async function handleCopy(): Promise<void> {
    await navigator.clipboard.writeText(value)
    setCopied(true)
    setTimeout(() => setCopied(false), FEEDBACK_DURATION_MS)
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      className="shrink-0 rounded p-1 text-text-tertiary hover:bg-surface-2 hover:text-text-secondary"
      title={copied ? 'Copied!' : 'Copy to clipboard'}
    >
      {copied ? <Check className="h-4 w-4 text-success" /> : <Copy className="h-4 w-4" />}
    </button>
  )
}
